import React from "react";
import AdminAddDocument from "../../Components/Admin/AdminAddDocument";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddDocumentPage = ()=>{
    return (
      <AdminAddDocument />
    )
}

export default AdminAddDocumentPage